module.exports = __webpack_public_path__ + "img/index-spot-3.abd77e55.png";